import { inject, Injectable } from '@angular/core';
import { DefaultTranspiler, TranspileParams } from '@jsverse/transloco';
import { BrandingService } from './branding.service';

/**
 * Fills `{{ brand_name }}` in every translation with the replica's
 * `GET /v1/branding` name, without each call site passing it.
 *
 * When the replica hasn't configured a name, no param is passed and Transloco
 * resolves the placeholder from the `brand_name` translation key itself —
 * the default brand, "AREEBPR", in both en.json and ar.json. An explicit
 * `brand_name` param still wins.
 */
@Injectable()
export class BrandTranspiler extends DefaultTranspiler {
  private readonly branding = inject(BrandingService);

  override transpile(params: TranspileParams) {
    const brandName = this.branding.configuredName();
    if (!brandName) return super.transpile(params);

    return super.transpile({
      ...params,
      params: { brand_name: brandName, ...params.params },
    });
  }
}
